<div class="custom-grid"
     [matTooltip]="iconTooltip"
     matTooltipClass="mat-tooltip-cp"
     [hidden]="isHidden">
    <button *ngIf="onlyIcon"
            mat-icon-button
            [disabled]="isDisabled || isButtonDisabled"
            (click)="onClick($event)">
        <mat-icon> {{ control.icon }} </mat-icon>
    </button>

    <button *ngIf="!onlyIcon" mat-stroked-button
            (click)="onClick($event)"
            [disabled]="isDisabled || isButtonDisabled">
        <mat-icon> {{ control.icon }} </mat-icon>
        {{ control.name | translate }}
    </button>
</div>


<div *ngIf="showGroups"
     class="cp-grid-default-back-drop">
    <div cdkDrag
         class="cp-grid-default-groups-container"
         [ngStyle]="{top:groupsY, left:groupsX}">
        <div class="cp-grid-default-groups-toolbar"
             cdkDragHandle>
            <mat-icon matTooltip="{{ 'se-ui-text-editor_cmd_close_tooltip' | translate }}"
                      class="cp-grid-default-groups-close-button"
                      (click)="onCloseGroups()">
                close
            </mat-icon>
        </div>
        <div>
            <div class="cp-grid-default-groups-item"
                 *ngFor="let group of _groups"
                 (click)="addGroupItems(group)">
                {{group.Description}}
            </div>
        </div>
    </div>
</div>
